module.exports = __webpack_public_path__ + "img/ico-user.c935cb1d.svg";